// Títulos organizados por categoría para todos los formularios de la aplicación

export const TITULOS_VIGENTES = [
  "Lic. en Trabajo Social",
  "Lic. en Servicio Social",
  "Tec. en Minoridad y Familia",
  "Trabajador Social (nivel terciario)",
  "Doctor en Trabajo Social"
];

export const TITULOS_ANTERIORES = [
  "Asistente Social",
  "Visitadore de Higiene",
  "Visitadore de Salud Publica",
  "Asist. Soc. Criminologico",
  "Asistente Escolar",
  "Lic. en Desarrollo Social"
];

// Todos los títulos para validación
export const TITULOS = [...TITULOS_VIGENTES, ...TITULOS_ANTERIORES];

// Componente JSX para renderizar el selector de títulos con grupos
export const TitulosOptions = () => (
  <>
    <option value="">Seleccionar</option>
    <optgroup label="Titulaciones vigentes">
      {TITULOS_VIGENTES.map(t => <option key={t} value={t}>{t}</option>)}
    </optgroup>
    <optgroup label="Titulaciones anteriores">
      {TITULOS_ANTERIORES.map(t => <option key={t} value={t}>{t}</option>)}
    </optgroup>
  </>
);
